module.exports = __webpack_public_path__ + "static/gq-80ad61b9e553410d26a7689748c9fa62.jpg";